import React from "react"

export const renderLabelRequired = (text) => (
  <>
    {text} <span style={{ color: "red" }}>*</span>
  </>
)
